export default class Repository {
  get relations()    { return this.provider.relations;    };
  get associations() { return this.provider.associations; };

  constructor(backend, provider) {
    this.backend  = backend;
    this.provider = provider;
  }
};
